import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { SadmEntityNamePipe } from '@modules/sadm/pipes/sadm-entity-name.pipe';
import { SadmEntityTypePipe } from '@modules/sadm/pipes/sadm-entity-type.pipe';
import { ActionButtonsComponent } from '@modules/shared/action-buttons/action-buttons.component';
import { ImageBrokenComponent } from '@modules/shared/image-broken/image-broken.component';
import { getMediaPreviewUri, SadmType } from '@pixacare/domain';
import { SadmGridEntity } from '../models/sadm-grid-entity';
import { SadmGridHeaderActionsService } from '../services/sadm-grid-header-actions.service';

@Component({
  selector: 'pxc-sadm-grid-header-cell',
  templateUrl: './sadm-grid-header-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageBrokenComponent, SadmEntityNamePipe, SadmEntityTypePipe, ActionButtonsComponent, TranslocoDirective],
  host: {
    class: 'flex items-start gap-3 py-3',
  },
})
export class SadmGridHeaderCellComponent {
  private readonly headerActionsService = inject(SadmGridHeaderActionsService);

  readonly entity = input.required<SadmGridEntity>();
  readonly sadmType = input<SadmType | null>(null);

  protected readonly imageError = signal(false);

  protected readonly isDraft = computed(() => this.entity().sadmEntityId === null);

  protected readonly mediaPreviewUri = computed(() => getMediaPreviewUri(this.entity().previewMedia));

  protected readonly actions = this.headerActionsService.getActions();
  protected readonly actionButtons = this.headerActionsService.getActionButtons();

  onImageLoadingError(): void {
    this.imageError.set(true);
  }
}
